import React, { useState, useEffect } from 'react';
import { registerParticipant } from '../api/user';
import { validateForm, createInitialFormState, loadValidationRules, loadDropdownData } from '../utils/form';
import { PARTICIPANT_FIELDS } from '../utils/formConfig';
import RowColLayout from '../components/RowColLayout';
import ErrorSection from '../components/ErrorSection';
import FormRenderer from '../components/FormRenderer';
import DocRequirement from '../components/DocRequirement';
import { useForm } from '../hooks/useForm';
import AvisoPrivacidad from '../components/AvisoPriv';

const ParticipantForm = ({
  title,
  token,
  onRegistered,
  onSkip,
  showMountainOption = false,
  needsMountainForm = false,
  onToggleMountain,
  txtBtn
}) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [etaAnswer, setEtaAnswer] = useState(null);
  const [snowActivity, setSnowActivity] = useState(needsMountainForm); // toggle state for snow activities
  

  const {
    formData,
    handleChange,
    dropdowns,
    loading: dataLoading,
    errors: FormStateError,
    fieldErrors,
    isComplete,
    isValid
  } = useForm({
    initialFields: PARTICIPANT_FIELDS,
    loadDropdowns: loadDropdownData,
    loadRules: loadValidationRules
  });

    // --- always at the top of the component ---
  useEffect(() => {
    const val = formData?.snow_activities;
    if (val !== undefined) {
      console.log("Syncing snowActivity with form:", val);
      setSnowActivity(val);           // update local state
      onToggleMountain?.(val);       // notify parent about mountain form
    }
  }, [formData?.snow_activities, onToggleMountain]);


  const isSubmitDisabled = !isComplete || !isValid || loading;

  if (dataLoading) return <p>Loading form data...</p>;
  if (FormStateError) return <p>Error loading form: {FormStateError.message}</p>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    // Check if the user wants to submit without selecting a snow activity option
    if (showMountainOption && snowActivity === false) {
      const confirmSubmit = window.confirm(
        '¿Estás seguro de no seleccionar una actividad de nieve? Este formulario podría estar incompleto.'
      );
      if (!confirmSubmit) {
        setLoading(false);
        return; // Do not proceed with submission
      }
    }

    if (!isValid) {
      setLoading(false);
      return;
    }

    const payload = {
      registration_token: token,
      ...formData,
      eta_answer: formData.eta,
      participant_needs_mountain: formData.snow_activities
    };

    // console.log("Participant Form payload before removing password congirmation:")
    // console.log(payload)

    // delete payload.confirm_password; 

    console.log("Participant Form payload to backend:")
    console.log(payload)

    try {
      const result = await registerParticipant(payload);
      const mainParticipantId = result.main_participant_id;

      if (!result.participant_id) {
        throw new Error('Participant ID missing');
      }

      // onRegistered(result);
      console.log("Backend response ParticipantForm")
      console.log(result)
  
      onRegistered({ ...result, mainParticipantId });
    } catch (err) {
      console.log("🔥 Backend error full object:", err);
      console.log("🔥 Backend error response:", err?.response);
      console.log("🔥 Backend error data:", err?.response?.data);

      // const apiError = err?.response?.data;

      // setError(
      //   typeof apiError === "object"
      //     ? JSON.stringify(apiError)
      //     : apiError?.message || "No se pudo registrar el participante"
      // );

      setError("Error al enviar datos, contáctanos en el botón de whatsapp para ayudarte");
      
    } finally {
      setLoading(false);
    }
  };

  // Handle snow activity toggle
  const handleSnowActivity = (value) => {
    console.log("Current snowActivity state:", snowActivity);
    console.log("Form snow_activities value:", formData.snow_activities);
    if (!value) {
      const confirmLeave = window.confirm(
        '¿Estás seguro de que no realizarás esquí o snowboard? Estarás renunciando a tu equipo (esquís o snowboard).'
      );
      if (confirmLeave) {
        setSnowActivity(value);
        onToggleMountain(value); // Toggle mountain form
      }
    } else {
      setSnowActivity(value);
      onToggleMountain(value); // Toggle mountain form
    }
  };

  return (
    // <section className="d-flex flex-column justify-content-between">
    <section className="d-flex flex-column justify-content-center">
      <RowColLayout>
        <h3>{title}</h3>
      </RowColLayout>

      <FormRenderer
        fields={PARTICIPANT_FIELDS}
        formData={formData}
        errors={fieldErrors}
        handleChange={(field, value) => {
          handleChange(field, value); // updates formData

          // Sync snow_activities to local state and parent callback
          if (field === "snow_activities") {
            setSnowActivity(value);      // local state
            onToggleMountain?.(value);   // notify parent for mountain form
          }
        }}
        handleSubmit={handleSubmit}
        dropdowns={{
          sex: dropdowns.sex_choices,
          eta: dropdowns.eta_choices,
          snow_activities: dropdowns.snow_activity_choices
        }}
        selectorMap={{ sex: "Género" }}
        buttonConfig={{
          mainText: txtBtn,
          secondaryText: onSkip ? "Skip" : null,
          onSecondaryClick: onSkip,
          disabled: isSubmitDisabled
        }}
      />
      <DocRequirement value={formData.eta} onChange={(val) => handleChange("eta", val)} />
      

      <ErrorSection error={error} errors={fieldErrors} />
    </section>
  );
};

export default ParticipantForm;
